import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { getEnv } from '../../ajax/env';

// -----------------------------
// Reducers
// -----------------------------

const getEnvReducer = async () => {
    // const { data } = await getEnv();
    return handleActions({}, {});
};

// const sharedReducers = combineReducers({
//     env,
// });

// -----------------------------
// Selectors
// -----------------------------

const getEnvState = state => state.Env;

// -----------------------------
// Export
// -----------------------------

export {
    getEnvReducer,
    getEnvState,
};
